import api from '.';

interface Auth {
  code: string;
  redirectUri: string;
}

export interface Request {
  email: string;
  password: string;
}

export interface Response {
  data: { token: string };
}

export async function signinSCG(auth: Auth) {
  const { data } = await api.post(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/auth/login-scg`,
    auth
  );
  return data;
}

export async function signinExt(request: Request) {
  const { data } = await api.post(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/auth/login`,
    request
  );
  return data;
}
